<template>
  <div>
    <v-container fluid>
      <v-card elevation="0" class="">
        <v-card-title class="ma-0 pa-0">
          <v-row no-gutters class="ma-0" justify="end">
            <v-col cols="12">
              <h3 class="my-2 mx-2 primary--text">
                {{ $t("settings.blocks.title") }}
              </h3>
            </v-col>
            <!-- <v-spacer v-if="$vuetify.breakpoint.mdAndUp"></v-spacer> -->
            <v-col cols="4">
              <v-text-field
                :label="$t('common.search')"
                v-model="search"
                class="mx-2"
                placeholder="Area Name"
                outlined
                dense
              >
              </v-text-field>
            </v-col>
            <v-menu>
              <template #activator="{ on, attrs }">
                <v-btn class="ml-2" v-on="on" v-bind="attrs" icon>
                  <v-icon>mdi-menu</v-icon>
                </v-btn>
              </template>
              <v-list class="text-body-2">
                <v-list-item @click="showRightSideDrawer('BLOCKS')">
                  <v-list-item-icon>
                    <v-icon color="primary"> mdi-plus-circle </v-icon>
                  </v-list-item-icon>
                  <v-list-item-text>
                    {{ $t("settings.blocks.btnTitle") }}
                  </v-list-item-text>
                </v-list-item>
                <v-list-item @click="exportData">
                  <v-list-item-icon>
                    <v-icon color="success"> mdi-application-export </v-icon>
                  </v-list-item-icon>
                  <v-list-item-text>
                    {{ $t("common.excel") }}
                  </v-list-item-text>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-row>
        </v-card-title>
        <v-data-table
          :footer-props="{ 'items-per-page-options': [50, 100, 150, 200, -1] }"
          :headers="headers"
          :hide-default-footer="footer"
          class="mt-2 datatable"
          id="blockTable"
          :items="blockLists"
          :search="search"
          :loading="loading"
          mobile-breakpoint="0"
          :options.sync="options"
          :server-items-length="totalBlocks"
        >
          <template v-slot:[`item._id`]="{ item }">
            <p class="my-0 py-0">
              {{
                options.page * options.itemsPerPage -
                  options.itemsPerPage +
                  blockLists
                    .map(function(x) {
                      return x._id;
                    })
                    .indexOf(item._id) +
                  1
              }}
            </p>
          </template>
          <template v-slot:[`item.nameEn`]="{ item }">
            <p
              class="my-0 py-0"
              v-for="(i, blockindex) in item.blocks"
              :key="`${blockindex}_nameEn`"
            >
              {{ i.nameEn }}
            </p>
          </template>
          <template v-slot:[`item.nameAr`]="{ item }">
            <p
              class="my-0 py-0"
              v-for="(i, blockindex) in item.blocks"
              :key="`${blockindex}_nameAr`"
            >
              {{ i.nameAr }}
            </p>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-row class="mx-auto" justify="center">
              <v-icon color="primary" class="mx-2" @click="editBlock(item)"
                >mdi-pencil</v-icon
              >
            </v-row>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      footer: false,
      search: "",
      variables: {
        limit: 10,
        skip: 0
      },
      options: {
        itemsPerPage: 50,
        page: 1
      },
      blockLists: [],
      totalBlocks: 10
    };
  },
  computed: {
    headers() {
      return [
        {
          text: "#",
          align: "left",
          value: "_id",
          sortable: false,
          width: 10
        },
        {
          text: `${this.$t("settings.blocks.areaName")} (${this.$t(
            "common.en"
          )})`,
          align: "left",
          value: "area.nameEn",
          sortable: false,
          width: 100
        },
        {
          text: `${this.$t("settings.blocks.areaName")} (${this.$t(
            "common.ar"
          )})`,
          align: "left",
          value: "area.nameAr",
          sortable: false,
          width: 100
        },
        {
          text: `${this.$t("settings.area.name")} (${this.$t("common.en")})`,
          align: "left",
          value: "nameEn",
          sortable: false,
          width: 100
        },
        {
          text: `${this.$t("settings.area.name")} (${this.$t("common.ar")})`,
          align: "left",
          value: "nameAr",
          sortable: false,
          width: 100
        },
        {
          text: this.$t("common.actions"),
          value: "actions",
          sortable: false,
          align: "left",
          width: 100
        }
      ].map(header => {
        header.align = "center";
        return header;
      });
    }
  },
  watch: {
    search() {
      this.loading = true;
      this.$apollo.queries.getBlocksUnderArea.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalBlocks,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter: {
          searchKey: this.search
        }
      });
      this.loading = false;
    },
    options() {
      this.$apollo.queries.getBlocksUnderArea.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalBlocks,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter: {
          searchKey: this.search
        }
      });
    }
  },
  apollo: {
    getBlocksUnderArea() {
      this.loading = true;
      return {
        query: require("@/settings/api/queries/blocks/blocks_under_area_query.graphql"),
        variables: {
          input: {
            limit: this.totalBlocks,
            skip: 0
          },
          filter: {
            searchKey: this.search
          }
        },
        result({ data, loading }) {
          // , loading, networkStatus, refetch
          this.blockLists = this.$format.cloneVariable(
            data.getBlocksUnderArea.blocksUnderArea
          );
          this.loading = loading;
          this.totalBlocks = data.getBlocksUnderArea.totalCount;
        }
      };
    }
  },
  mounted() {
    // this.$root.$on('deleteItems', data => {
    //   if (data.module === 'blocks') {
    //     const input = data.item._id
    //     deleteBlock(input).then(data => {
    //       if (data.data.deleteBlock) {
    //         this.$apollo.queries.getBlocksUnderArea.refetch({
    //           limit:
    //             this.options.itemsPerPage !== -1
    //               ? this.options.itemsPerPage
    //               : this.totalBlocks,
    //           skip:
    //             this.options.page * this.options.itemsPerPage -
    //             this.options.itemsPerPage
    //         })
    //         this.$root.$emit("snackbar", {
    //           snackbar: true,
    //           text: this.$t("common.deleteSuccess"),
    //           color: "green"
    //         });
    //         this.$store.commit('DELETE_BTN_LOADING', false)
    //       }
    //     })
    //   }
    // })
    this.$root.$on("blockTable", () => {
      this.options.itemsPerPage = 50;
      this.$set(this.options, this.options.itemsPerPage, 50);
    });
    this.$root.$on("refetchBlock", () => {
      this.$apollo.queries.getBlocksUnderArea.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalBlocks,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter: {
          searchKey: this.search
        }
      });
    });
    this.$root.$on("searchBlocks", data => {
      this.search = data;
    });
    this.$root.$on("exportBlocks", () => {
      this.exportData();
    });
  },
  methods: {
    showRightSideDrawer(item) {
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
      this.$store.commit("APP_SETTINGS_FORMNAME", item);
    },
    exportData() {
      this.$apollo.queries.getBlocksUnderArea
        .refetch({
          limit: 0,
          skip: 0
        })
        .then(data => {
          this.options.itemsPerPage = data.data.getBlocksUnderArea.totalCount;
          this.areaLists = data.data.getBlocksUnderArea.blocksUnderArea;
          this.footer = true;
          setTimeout(() => {
            this.htmlToExcel("blockTable", "block");
          }, 1000);
        });
    },
    editBlock(item) {
      this.$store.commit("EDIT_BLOCK", item);
      this.$store.commit("IS_EDIT_BLOCK", true);
      this.$store.commit("APP_SETTINGS_FORMNAME", "BLOCKS");
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
    }
  },
  beforeDestroy() {
    this.$root.$off("deleteItems");
    this.$root.$off("blockTable");
    this.$root.$off("refetchBlock");
    this.$root.$off("searchBlocks");
    this.$root.$off("exportBlocks");
  }
};
</script>
<style scoped>
.datatable >>> .v-data-footer__select {
  direction: ltr !important;
}
.datatable >>> .v-data-footer__pagination {
  direction: ltr !important;
}
</style>
